/* UTILS */
import t from "../../../../../utils/translate";
import { COMPOUND } from "../../../constants";
import applangaKeyMap from "./applangaKeyMap";
/* COMPONENTS */
import Column from "../../../../Column";
import Break from "../../../../ClinicCheckout/Payment/componets/Break";
import BulletItem from "components/BulletItem";
import { ReactComponent as Tag } from "../../../imgs/tag.svg";
/* STYLES */
import styles from "./styles.module.scss";

const MedsCard = ({ urlParam = COMPOUND }) => {
  const hasLimitedTimeOffer = urlParam === COMPOUND;
  const { headline, subheading, details, img } = applangaKeyMap[urlParam] || {};

  const renderBulletItems = () => {
    return applangaKeyMap[urlParam].bulletlist.map((item, i) => (
      <BulletItem key={i}>{t(`${item}`)}</BulletItem>
    ));
  };

  return (
    <Column className={styles.content}>
      <h2 className={styles.title}>{t("CLINIC_CHECKOUT_YOU_CHOSE")}</h2>
      <div className={styles.upperWrapper}>
        <div className={styles.textColumn}>
          <div className={styles.headline}>{t(headline)}</div>
          <div className={styles.subheading}>{t(subheading)}</div>
          <div className={styles.details}>{t(details)}</div>
        </div>
        <div className={styles.ellipseColumn}>
          <img src={img} className={styles.img} />
        </div>
      </div>
      <Break />
      <div className={styles.checklist}>
        <div className={styles.checklistTitle}>
          {t("CHECKLIST_INCLUDES") || "Includes:"}
        </div>
        <div className={styles.checklistItems}>{renderBulletItems()}</div>
      </div>
      {hasLimitedTimeOffer && (
        <div className={styles.offer}>
          <div className={styles.offerTitleWrapper}>
            <Tag className={styles.tag} />
            <span className={styles.offerTitle}>
              {t("CLINIC_CHECKOUT_LIMITED_TIME")}
            </span>
          </div>
          <div className={styles.offerDetails}>
            {t("COMPOUNDED_GLP1_CONSULTATION_OFFER")}
            <span className={styles.priceWrapper}>
              <span className={styles.priceCrossout}>
                {/* placeholder */}
                $49
              </span>
              <span className={styles.price}>{/* placeholder */}$0</span>
            </span>
          </div>
        </div>
      )}
    </Column>
  );
};

export default MedsCard;
